export const stringToBoolean = (value: string | null): boolean => {
    if (value === null) return false;
    return value?.toLowerCase() === "true" || value === "1";
  };